module.exports = __webpack_public_path__ + "static/jerry-selitto-400w-103018-c94cd1fd8d505c3513cb05564f055f7f.jpg";